import React from 'react';
import { connect, Provider } from 'react-redux';
import PropTypes from 'prop-types';

export const canvasContext = React.createContext();

/**
 * canvas provider with custom context
 * @param {object} params - params
 * @param {object} params.children - children
 * @param {object} params.store - redux store
 * @returns {Function} hoc
 */
export const CanvasProvider = ({ children, store }) => {
  return (
    <Provider context={canvasContext} store={store}>
      {children}
    </Provider>
  );
};

CanvasProvider.propTypes = {
  children: PropTypes.object,
  store: PropTypes.object.isRequired
};

CanvasProvider.defaultProps = {
  children: []
};

/**
 * connect to canvas redux store
 * @param {Function} mapState - mapStateToProps
 * @param {(Function|object)} mapDispatch - mapDispatchToProps
 * @param {Function} mergeProps - mergeProps
 * @param {object} options - options
 * @returns {Function} hoc
 */
export default function connectCanvasProvider(
  mapState,
  mapDispatch,
  mergeProps,
  options = {}
) {
  return connect(mapState, mapDispatch, mergeProps, { ...options, context: canvasContext });
}
